import {
	get,
	post
} from './http'


//获取直播分类
export let getLiveRoomType = p => get('/getLiveRoomType', p);

//获取直播列表
export let getLiveList = p => get('/list', p);

//预约直播
export let bookRoom = p => post('/bookRoom', p);

//收藏直播
export let collectRoom = p => post('/collectRoom', p);

//我的预约
export let queryMyBook = p => get('/queryMyBook/?token='+p);

//我的收藏
export let queryMyCollect = p => get('/queryMyCollect/?token='+p);
